export class ApiError extends Error {
  status: number;

  constructor(message: string, status: number) {
    super(message);
    this.status = status;
  }
}

export type ClientWait = { id: string; number: string; since: string; reason: string; seconds: number };
let waitHandler: ((waits: ClientWait[]) => Promise<boolean>) | null = null;
export function registerClientWaitHandler(handler: typeof waitHandler) { waitHandler = handler; }

export async function apiRequest<T>(
  path: string,
  options: RequestInit = {},
  attempt = 0,
): Promise<T> {
  const response = await fetch(path, {
    ...options,
    credentials: "same-origin",
    headers: {
      ...(options.body ? { "content-type": "application/json" } : {}),
      ...options.headers,
    },
  });
  if (response.status === 204) return undefined as T;
  const body = await response.json().catch(() => ({}));
  if (!response.ok) {
    if (body?.code === 'CLIENT_WAIT_REQUIRED' && waitHandler && attempt < 3) {
      if (await waitHandler(body.waits)) {
        if (options.signal?.aborted) throw new DOMException('Solicitud cancelada', 'AbortError');
        return apiRequest<T>(path, options, attempt + 1);
      }
      throw new ApiError('La orden sigue esperando al cliente. No se aplicaron los cambios; tu formulario permanece abierto.', 409);
    }
    throw new ApiError(body?.error || "No se pudo completar la operación.", response.status);
  }
  return body as T;
}
